import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const TYPE_TEXT = '[Type: Text][Vis: high] - Feature Set Category Name';

export default defineMessages({
  TEAM_COLLABORATION: {
    id: 'Pricing.categoryCopy.TeamCollaboration',
    defaultMessage: 'Team Collaboration',
    desc: {
      id: 'Pricing.categoryCopy.TeamCollaboration',
      message: `${TYPE_TEXT} - TeamCollaboration`,
      project: PROJECT_NAME,
    },
  },
  TEAM_MANAGEMENT: {
    id: 'Pricing.categoryCopy.TeamManagement',
    defaultMessage: 'Team Management',
    desc: {
      id: 'Pricing.categoryCopy.TeamManagement',
      message: `${TYPE_TEXT} - TeamManagement`,
      project: PROJECT_NAME,
    },
  },
  ENTERPRISE_GRADE_SECURITY: {
    id: 'Pricing.categoryCopy.EnterpriseGradeSecurity',
    defaultMessage: 'Enterprise-grade admin and security',
    desc: {
      id: 'Pricing.categoryCopy.EnterpriseGradeSecurity',
      message: `${TYPE_TEXT} - EnterpriseGradeSecurity`,
      project: PROJECT_NAME,
    },
  },
  SURVEY_CAPABILITIES: {
    id: 'Pricing.categoryCopy.SurveyCapabilities',
    defaultMessage: 'Survey Capabilities',
    desc: {
      id: 'Pricing.categoryCopy.SurveyCapabilities',
      message: `${TYPE_TEXT} - SurveyCapabilities`,
      project: PROJECT_NAME,
    },
  },
  FAST_SUPPORT: {
    id: 'Pricing.categoryCopy.FastSupport',
    defaultMessage: 'Fast Support',
    desc: {
      id: 'Pricing.categoryCopy.FastSupport',
      message: `${TYPE_TEXT} - FastSupport`,
      project: PROJECT_NAME,
    },
  },
  SURVEY_BUILDER: {
    id: 'Pricing.categoryCopy.SurveyBuilder',
    defaultMessage: 'Survey Builder',
    desc: {
      id: 'Pricing.categoryCopy.SurveyBuilder',
      message: `${TYPE_TEXT} - SurveyBuilder`,
      project: PROJECT_NAME,
    },
  },
  CUSTOMIZATION_BRANDING: {
    id: 'Pricing.categoryCopy.CustomizationBranding',
    defaultMessage: 'Customization & Branding',
    desc: {
      id: 'Pricing.categoryCopy.CustomizationBranding',
      message: `${TYPE_TEXT} - CustomizationBranding`,
      project: PROJECT_NAME,
    },
  },
  ANALYSIS_REPORTING: {
    id: 'Pricing.categoryCopy.AnalysisReporting',
    defaultMessage: 'Analysis & Reporting',
    desc: {
      id: 'Pricing.categoryCopy.AnalysisReporting',
      message: `${TYPE_TEXT} - AnalysisReporting`,
      project: PROJECT_NAME,
    },
  },
  RESPONSE_MANAGEMENT: {
    id: 'Pricing.categoryCopy.ResponseManagement',
    defaultMessage: 'Response Management',
    desc: {
      id: 'Pricing.categoryCopy.ResponseManagement',
      message: `${TYPE_TEXT} - ResponseManagement`,
      project: PROJECT_NAME,
    },
  },
  ENHANCED_SECURITY: {
    id: 'Pricing.categoryCopy.EnhancedSecurity',
    defaultMessage: 'Enhanced Security',
    desc: {
      id: 'Pricing.categoryCopy.EnhancedSecurity',
      message: `${TYPE_TEXT} - EnhancedSecurity`,
      project: PROJECT_NAME,
    },
  },
  PARTNER_INTEGRATIONS: {
    id: 'Pricing.categoryCopy.PartnerIntegrations',
    defaultMessage: 'Partner Integrations & APIs',
    desc: {
      id: 'Pricing.categoryCopy.PartnerIntegrations',
      message: `${TYPE_TEXT} - PartnerIntegrations`,
      project: PROJECT_NAME,
    },
  },
});
